'use client';

import { c as _c } from "react/compiler-runtime";
import React, { createContext, useContext } from 'react';
interface AssetImageContextType {
  preloadedAssetImage: React.ReactNode;
}
const AssetImageContext = createContext<AssetImageContextType | null>(null);
interface AssetImageProviderProps {
  children: React.ReactNode;
  preloadedAssetImage: React.ReactNode;
}
export const AssetImageProvider = t0 => {
  const $ = _c(5);
  const {
    children,
    preloadedAssetImage
  } = t0;
  let t1;
  if ($[0] !== preloadedAssetImage) {
    t1 = {
      preloadedAssetImage
    };
    $[0] = preloadedAssetImage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <AssetImageContext.Provider value={t1}>{children}</AssetImageContext.Provider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export const useAssetImage = () => {
  const context = useContext(AssetImageContext);
  if (!context) {
    throw new Error("useAssetImage must be used within an AssetImageProvider");
  }
  return context;
};